import React, { Component } from "react";
var config = require('./config.js');

const website = config.website;


class Warning extends Component {

  /**
   * Clears user-related session keys when the warning page is loaded.
   * @param {Object} [none] - This lifecycle method does not accept parameters.
   * @return {void} Does not return a value.
   */
  componentDidMount() {
    sessionStorage.removeItem('staff');
    sessionStorage.removeItem('super');
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('id_s');
    sessionStorage.removeItem('admin');
    sessionStorage.removeItem('id_e');
    sessionStorage.removeItem('version');
    sessionStorage.removeItem('int');
    sessionStorage.removeItem('email');
  }


  /**
   * Renders the unauthorized access warning content.
   * @param {Object} [none] - This render method does not accept parameters.
   * @return {JSX.Element} Warning page UI.
   */
  render(){
    return (
      <div className = 'warning-msg'>
        <br /><br />
        <h1>
            Oops... You cannot access this page
        </h1>
        <div>

            <h2>Please make sure that <br /> <br /></h2>
            <h3>
              1. You have authority to access this page. <br /><br />
            </h3>
            <h3>
              2. Log in with your navigators account.<br /><br />
            </h3>

            <h3>
              <a href={website}>Return to the Reserves Service.</a>
            </h3>


        </div>


      </div>


    )
  }
}


export default Warning;
